import './all.css';
import { useState, useEffect } from 'react';


export function Languages({ style }) {
  const [layersCount, setLayersCount] = useState(2); // default for laptop/desktop

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 1024) setLayersCount(3); // tablet & mobile
      else setLayersCount(2); // laptop/desktop
    };

    handleResize(); // set initial layers
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mostUsedLang = [
    { name: "JAVA", img: "java.png" },
    { name: "SPRING", img: "spring.png" },
    { name: "REACT", img: "react.png" },
    { name: "JS", img: "javascript.png" },
    { name: "HTML", img: "HTML.png" },
    { name: "CSS", img: "css.png" },
    { name: "C", img: "cplus.png" },
    { name: "MONGODB", img: "mongo-db.png" },
    { name: "MYSQL", img: "mysql.png" },
    { name: "SQL", img: "SQLDeveloper.png" },
    { name: "MUI", img: "mui.png" },
    { name: "ORACLE", img: "Oracle.png" },
    { name: "TAILWINDCSS", img: "tailwindcss.png" },
  ];

  const experiencedLang = [
    { name: "SPRING", img: "spring.png" },
    { name: "REACT", img: "react.png" },
    { name: "JAVA", img: "java.png" },
    { name: "JS", img: "javascript.png" },
    { name: "Maven", img: "Maven.png" },
    { name: "SQL", img: "SQLDeveloper.png" },
    { name: "ORACLE", img: "Oracle.png" },
    { name: "JUNIT", img: "junit.png" },
    { name: "ELK", img: "elk.png" },
    { name: "REDIS", img: "redis.png" },
    { name: "HTML", img: "html.png" },
    { name: "CSS", img: "css.png" },
    { name: "CANVA", img: "canva.png" },
    { name: "SPLINE", img: "spiline.png" },
  ];

  const renderTechCards = (techArray) => {
    const layerSize = Math.ceil(techArray.length / layersCount);
    const layers = [];
    for (let i = 0; i < layersCount; i++) {
      const start = i * layerSize;
      const end = start + layerSize;
      const layerItems = techArray.slice(start, end);
      if (layerItems.length > 0) {
        layers.push(
          <div className="exp-box1" key={i}>
            {layerItems.map((tech, index) => (
              <div className="ImgOfBoxTech" key={index}>
                <img src={tech.img} alt={tech.name} />
                <h5>{tech.name}</h5>
              </div>
            ))}
          </div>
        );
      }
    }
    return layers;
  };

  return (
    <div className={`container-fluid all-tech-page ${style}`}>
      <div className="box1">
        <div className="mb-3"><span>Most Used</span></div>
        <div className="all-exp-card">
          {renderTechCards(mostUsedLang)}
        </div>
      </div>
      <div className="box2">
        <div><span>Experienced</span></div>
        <div className="all-exp-card">
          {renderTechCards(experiencedLang)}
        </div>
      </div>
    </div>
  );
}
